"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4746],{

/***/ 22047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86788);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var StyledSwiper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "Carousel__StyledSwiper", componentId: "sc-1rkz4rr-0" })(["position:relative;min-width:100%;"]);



var Button = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].a.withConfig({ displayName: "Carousel__Button", componentId: "sc-1rkz4rr-1" })(["width:48px;height:48px;line-height:48px;border:solid 1px rgb(234,234,234);background-color:transparent;position:absolute;top:50%;margin-top:-24px;display:block;cursor:pointer;z-index:2;text-align:center;color:", ";&:before{font-size:18px;font-weight:bold;}@media (max-width:1405px){background-color:#ffffff;color:black;border:0;}&.disabled{display:none;}", ";&.next{left:auto;right:", ";@media (max-width:1405px){right:20px;}}&.previous{right:auto;left:", ";transform:rotate(180deg);@media (max-width:1405px){left:20px;}}@media (max-width:", "){display:none;}"],














function (props) {return props.theme.colors.neutrals.gray;},
















function (props) {return (
    props.controllersIn ? "\n          background-color: rgba(0, 0, 0, 0.6);\n          color: white;\n          border: 0;\n        " :





    null);},



function (props) {return props.controllersIn ? '20px' : '-70px';},








function (props) {return props.controllersIn ? '20px' : '-70px';},







function (props) {return "".concat(props.theme.viewports.mobile, "px");});












var Carousel = function Carousel(props) {var _props$spaceBetween, _props$spaceBetween2;
  var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var className = props.className;
  var sectionId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Date.now().toString(16));
  var prevClassname = "swiper-custom-previous-".concat(sectionId.current);
  var nextClassname = "swiper-custom-next-".concat(sectionId.current);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    swiperRef.current.slideTo(props.activeSlideIndex);
  }, [props.activeSlideIndex]);

  var itemPerView = props.itemPerView || 4;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledSwiper, { className: className, children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
          style: { height: 'max-content' },
          onSwiper: function onSwiper(swiper) {
            swiperRef.current = swiper;
          },
          modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Lazy */ .oM, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr],
          spaceBetween: 30,
          slidesPerView: 1,
          slidesPerGroup: 1,
          navigation: {
            prevEl: ".".concat(prevClassname),
            nextEl: ".".concat(nextClassname),
            disabledClass: 'disabled' },

          loop: props.loopSlider,
          breakpoints: {
            1240: {
              slidesPerView: itemPerView,
              spaceBetween: (_props$spaceBetween = props.spaceBetween) !== null && _props$spaceBetween !== void 0 ? _props$spaceBetween : 30 },

            1024: {
              slidesPerView: 3,
              spaceBetween: (_props$spaceBetween2 = props.spaceBetween) !== null && _props$spaceBetween2 !== void 0 ? _props$spaceBetween2 : 30 },

            768: {
              slidesPerView: 2,
              spaceBetween: 20 },

            250: {
              slidesPerView: 1,
              spaceBetween: 15 } }, children:



          react__WEBPACK_IMPORTED_MODULE_0__.Children.map(props.children, function (child, i) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, { children: child }, i));}) }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Button, {
          className: "next ygb-icon-slider_arrow ".concat(nextClassname),
          controllersIn: props.controllersIn }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Button, {
          className: "previous ygb-icon-slider_arrow ".concat(prevClassname),
          controllersIn: props.controllersIn })] }) }));




};
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 70300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .H2SectionHeader */ .L0).withConfig({ displayName: "SectionHeader__Header", componentId: "sc-j2xtiu-0" })(["", ""],
_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .sectionTitleStyle */ .d1);











var SectionHeader = function SectionHeader(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        className: props.className,
        justifyContent: "space-between",
        alignItems: "center", children: [/*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Header, { className: "SectionHeader--H2SectionHeader", children:
            props.title }),

          props.subTitle && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, _objectSpread(_objectSpread({},
          props.subTitleStyle ?
          { customStyle: props.subTitleStyle } :
          {}), {}, { children:

            props.subTitle })),


          props.secondSubtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, { children: props.secondSubtitle })] }),

        props.button ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flexShrink: 0, ml: [40, 40, 0], children:
          props.button }) :

        null] }) }));};




/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);

/***/ }),

/***/ 24746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "A1": function() { return /* binding */ SubscriptionBoxTitle; },
/* harmony export */   "F9": function() { return /* binding */ HighlitedSectionDynamic; },
/* harmony export */   "H8": function() { return /* binding */ SubscriptionsWrapper; },
/* harmony export */   "IQ": function() { return /* binding */ SubscriptionBoxBilled; },
/* harmony export */   "Iq": function() { return /* binding */ SubscriptionBox; },
/* harmony export */   "Kp": function() { return /* binding */ SingleColumnParagraph; },
/* harmony export */   "Lq": function() { return /* binding */ SubscriptionBoxPrice; },
/* harmony export */   "U3": function() { return /* binding */ MainTitle; },
/* harmony export */   "UG": function() { return /* binding */ SubscriptionTags; },
/* harmony export */   "Vo": function() { return /* binding */ BestPriceLabel; },
/* harmony export */   "WC": function() { return /* binding */ MainDescription; },
/* harmony export */   "Z7": function() { return /* binding */ SubscriptionTag; },
/* harmony export */   "Zc": function() { return /* binding */ SubscriptionBoxOldPrice; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "cN": function() { return /* binding */ SubscriptionBoxPriceWrapper; },
/* harmony export */   "e4": function() { return /* binding */ SingleColumnParagraphInner; },
/* harmony export */   "eu": function() { return /* binding */ SingleColumnTitle; },
/* harmony export */   "hI": function() { return /* binding */ SubscriptionTitle; },
/* harmony export */   "sh": function() { return /* binding */ ColumnImage; },
/* harmony export */   "ve": function() { return /* binding */ HighlitedSectionParentDynamic; },
/* harmony export */   "wv": function() { return /* binding */ ColumnParagraph; },
/* harmony export */   "yo": function() { return /* binding */ HeroImageTitle; }
/* harmony export */ });
/* unused harmony exports HighlitedSection, HighlitedSectionParent, SubscriptionBoxBilledSave, SubscriptionSubTitle */
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var _organisms_Carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8033);
/* harmony import */ var _layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _SectionHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);







/** Types */

/** Components */
// export const Devider = styled.div`
//   height: 1px;
//   display: block;
//   background-color: rgba(0, 0, 0, 0.87);
//   border: 0;
// `;

var GraySectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__GraySectionWrapper", componentId: "sc-183btc0-0" })(["background-color:#f7f7f7;"]);



var HeroSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__HeroSectionWrapper", componentId: "sc-183btc0-1" })(["display:block;background-color:", ";text-align:center;"],

function (props) {return props.theme.colors.primary['blue-4'];});



var HeroImageSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__HeroImageSectionWrapper", componentId: "sc-183btc0-2" })(["background-image:url('/static/register_social_hero.jpg');background-repeat:no-repeat;background-size:cover;background-position:center bottom;text-align:left;border-radius:3px;"]);









var HighlitedSection = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__HighlitedSection", componentId: "sc-183btc0-3" })(["background-color:rgba(167,141,81,0.9);height:100%;position:absolute;top:0;bottom:0;display:flex;"]);








var HighlitedSectionDynamic = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__HighlitedSectionDynamic", componentId: "sc-183btc0-4" })(["background-color:", ";padding-top:6.17%;padding-bottom:6.17%;display:flex;"],
function (p) {return (
    p.summerCampaign ? 'rgba(136, 191, 189, 0.7)' : 'rgba(17, 158, 221, 0.75)');});





var HighlitedSectionParent = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__HighlitedSectionParent", componentId: "sc-183btc0-5" })(["min-height:560px;max-height:600px;position:relative;@media (max-width:", "){min-height:350px;max-height:400px;}"],



function (props) {return "".concat(props.theme.viewports.tablet, "px");});





var HighlitedSectionParentDynamic = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__HighlitedSectionParentDynamic", componentId: "sc-183btc0-6" })(["position:relative;"]);



var SubscriptionTable = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__SubscriptionTable", componentId: "sc-183btc0-7" })(["background-image:url('/static/subscription_bg.jpg');background-repeat:no-repeat;background-size:cover;"]);





var SubscriptionTags = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__SubscriptionTags", componentId: "sc-183btc0-8" })(["border-radius:3px;background-color:rgba(102,123,145,0.2);"]);




var SubscriptionTag = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__SubscriptionTag", componentId: "sc-183btc0-9" })(["position:relative;color:", ";font-size:13px;font-weight:300;line-height:23px;"],

function (props) {return props.theme.colors.neutrals.black;});





var SubscriptionsWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC).withConfig({ displayName: "components__SubscriptionsWrapper", componentId: "sc-183btc0-10" })(["display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));column-gap:10px;row-gap:20px;"]);






var SubscriptionBox = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__SubscriptionBox", componentId: "sc-183btc0-11" })(["position:relative;display:flex;flex-direction:column;align-items:center;justify-content:space-between;color:", ";text-align:center;text-decoration:none;border-radius:3px;padding:40px 25px;background-color:white;box-shadow:0 2px 16px 0 rgba(0,0,0,0.12);transition:box-shadow 0.3s ease-in,transform 0.5s ease;overflow:hidden;@media (max-width:", "){padding:25px 15px;}&:hover{box-shadow:0 2px 20px 0 rgba(0,0,0,0.2);transform:scale(1.1);}"],





function (props) {return props.theme.colors.neutrals.black;},









function (props) {return "".concat(props.theme.viewports.tablet, "px");});









var SubscriptionBoxTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].h3.withConfig({ displayName: "components__SubscriptionBoxTitle", componentId: "sc-183btc0-12" })(["color:", ";font-size:13px;font-weight:600;letter-spacing:1.18px;line-height:19px;text-transform:uppercase;"],
function (props) {return props.theme.colors.neutrals.black;});







var SubscriptionBoxPriceWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__SubscriptionBoxPriceWrapper", componentId: "sc-183btc0-13" })(["display:flex;flex-direction:column;"]);




var SubscriptionBoxOldPrice = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].span.withConfig({ displayName: "components__SubscriptionBoxOldPrice", componentId: "sc-183btc0-14" })(["color:", ";font-size:24px;font-weight:300;line-height:1.4;text-decoration:line-through;"],
function (_ref) {var theme = _ref.theme;return theme.colors.neutrals.black;});






var SubscriptionBoxPrice = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].span.withConfig({ displayName: "components__SubscriptionBoxPrice", componentId: "sc-183btc0-15" })(["color:#243240;font-size:32px;font-weight:600;line-height:51px;letter-spacing:-1.5px;margin-right:14px;"]);








var SubscriptionBoxBilled = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "components__SubscriptionBoxBilled", componentId: "sc-183btc0-16" })(["max-width:300px;font-size:13px;font-weight:600;line-height:23px;min-height:46px;margin:18px auto 20px;"]);








var SubscriptionBoxBilledSave = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].strong.withConfig({ displayName: "components__SubscriptionBoxBilledSave", componentId: "sc-183btc0-17" })(["color:", ";display:block;"],
function (props) {return props.theme.colors.primary['pink-1'];});



var Label = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].label.withConfig({ displayName: "components__Label", componentId: "sc-183btc0-18" })(["color:#ffffff;font-size:11px;font-weight:500;line-height:14px;text-align:center;padding:4px 11.5px;border-radius:2px;display:inline-block;background-color:", ";margin-bottom:5px;"],








function (props) {return props.color ? props.color : '#404040';});



var BestPriceLabel = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__BestPriceLabel", componentId: "sc-183btc0-19" })(["position:absolute;top:30px;right:-76px;width:240px;font-size:11px;color:", ";font-weight:600;text-align:center;text-transform:uppercase;letter-spacing:1px;background-color:", ";padding:8px;transform:rotate(45deg);"],





function (props) {return props.theme.colors.neutrals['white'];},




function (_ref2) {var theme = _ref2.theme;return theme.colors.primary['blue-2'];});




var MainTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].h1.withConfig({ displayName: "components__MainTitle", componentId: "sc-183btc0-20" })(["color:", ";font-size:48px;font-weight:bold;line-height:58px;text-align:center;margin:0;margin-bottom:20px;@media (max-width:", "){font-size:32px;line-height:42px;}"],
function (props) {return props.theme.colors.neutrals.black;},







function (props) {return "".concat(props.theme.viewports.tablet, "px");});





var MainDescription = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "components__MainDescription", componentId: "sc-183btc0-21" })(["color:", ";font-size:13px;line-height:23px;margin:0;margin-top:20px;"],
function (props) {return props.theme.colors.neutrals.black;});






var HeroImageTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].h1.withConfig({ displayName: "components__HeroImageTitle", componentId: "sc-183btc0-22" })(["color:#ffffff;font-size:28px;font-weight:300;line-height:34px;text-align:left;"]);







var ColumnParagraph = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "components__ColumnParagraph", componentId: "sc-183btc0-23" })(["margin:0;padding:0;color:", ";font-size:13px;line-height:23px;"],


function (props) {return props.theme.colors.neutrals.black;});




var ColumnImage = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].img.withConfig({ displayName: "components__ColumnImage", componentId: "sc-183btc0-24" })(["margin:0;padding:0;max-width:", ";width:100%;pointer-events:none;"],


function (props) {return props.maxWidth ? "".concat(props.maxWidth, "px") : "100%";});




var SingleColumnTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].h2.withConfig({ displayName: "components__SingleColumnTitle", componentId: "sc-183btc0-25" })(["color:", ";font-size:34px;font-weight:300;line-height:41px;text-transform:uppercase;margin:0;margin-bottom:15px;"],
function (props) {return props.theme.colors.neutrals.black;});








var SingleColumnParagraphInner = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "components__SingleColumnParagraphInner", componentId: "sc-183btc0-26" })(["", ";overflow:hidden;margin:0;padding:0;max-height:", ";font-size:14px;line-height:26px;color:", ";transition:all ease-in 0.3s;"],
function (props) {return (
    !props.expanded ?
    (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.css)(["&:before{content:'';position:absolute;z-index:1;bottom:0;left:0;right:0;top:0;background:rgb(247,247,247);background:linear-gradient( 0deg,rgba(247,247,247,1) 0%,rgba(247,247,247,0) 50% );}"]) :
















    null);},



function (props) {return props.expanded ? null : '240px';},


function (props) {return props.theme.colors.neutrals.black;});


var SingleColumnParagraph = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "components__SingleColumnParagraph", componentId: "sc-183btc0-27" })(["color:", ";position:relative;"],
function (props) {return props.theme.colors.neutrals.black;});



var SubscriptionTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].h2.withConfig({ displayName: "components__SubscriptionTitle", componentId: "sc-183btc0-28" })(["color:", ";font-size:34px;font-weight:500;line-height:41px;text-align:center;margin:0;padding:0;margin-bottom:15px;"],
function (props) {return props.theme.colors.neutrals.black;});









var SubscriptionSubTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "components__SubscriptionSubTitle", componentId: "sc-183btc0-29" })(["color:", ";font-size:18px;font-weight:300;margin:0;padding:0;margin-bottom:20px;line-height:21px;text-align:center;"],
function (props) {return props.theme.colors.neutrals.black;});









var Section = function Section(template) {
  switch (template.type) {
    case 'hero':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HeroSectionWrapper, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            flexDirection: 'column',
            mt: "60px",
            mb: "60px",
            px: [25, 25, 10], children: /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
              flexWrap: 'nowrap',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center', children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { width: [1, 1, 1 / 2], children: template.children }) }) }) }));




    case 'hero-image':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { fullWidth: true, as: GraySectionWrapper, pt: 30, px: [25, 25, 10], children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            as: HeroImageSectionWrapper,
            flexDirection: 'column',
            px: [0, 30, 60], children: /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { as: HighlitedSectionParent, alignItems: 'center', children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { width: [1, 1, 2 / 5], as: HighlitedSection, px: 40, py: 20, children:
                template.children }) }) }) }));





    case 'subscription':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { fullWidth: true, as: SubscriptionTable, py: 60, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { px: [25, 25, 10], flexDirection: 'column', children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { alignItems: 'center', justifyContent: 'center', children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flex: "1", children: template.children }) }) }) }));




    case '2-columns':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
          flexDirection: 'column',
          mt: "53px",
          mb: "53px",
          px: [25, 25, 106], children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flex: "1", children: template.children }) }) }));



    case '1-column':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { fullWidth: true, as: GraySectionWrapper, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { flexDirection: 'column', my: "60px", px: [25, 25, 10], children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center', children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mx: "60px", width: [1, 1, 1 / 2], children:
                template.children }) }) }) }));





    case 'testimonials':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { fullWidth: true, as: GraySectionWrapper, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, { flexDirection: 'column', my: "60px", px: [25, 25, 10], children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "50px", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_SectionHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_6__/* .Trans */ .cC, {
                  id: "regsocial.testimonial_title",
                  message: 'What our members think' }) }) }), /*#__PURE__*/




            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_organisms_Carousel__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { itemPerView: 3, children: template.children })] }) }));



    default:
      break;}

};

/***/ }),

/***/ 8033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CarouselItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var _components_Carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22047);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var BasicCarouselCard = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "Carousel__BasicCarouselCard", componentId: "sc-1ydziwj-0" })(["@media (max-width:", "){&.swiper-slide-prev,&:first-of-type{margin-left:20px;}&:first-of-type.swiper-slide-prev{margin-left:40px;}}@media (max-width:", "){max-width:270px;&.swiper-slide-prev,&:first-of-type{margin-left:15px;}&:first-of-type.swiper-slide-prev{margin-left:30px;}}"],
function (props) {return "".concat(props.theme.viewports.tablet, "px");},










function (props) {return "".concat(props.theme.viewports.mobile, "px");});













var CarouselItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BasicCarouselCard).withConfig({ displayName: "Carousel__CarouselItem", componentId: "sc-1ydziwj-1" })(["max-width:", ";"],
function (p) {return p.maxWidth ? "".concat(p.maxWidth, "px") : "407px";});


var Carousel = function Carousel(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_Carousel__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      listItems: props.listItems,
      spaceBetween: props.spaceBetween,
      inverted: props.inverted,
      itemPerView: props.itemPerView,
      loopSlider: props.loopSlider, children:

      props.children }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ })

}]);